import * as ActionTypes from '../constants/ActionTypes'

// **************************************************************************************************************
export const showPopupWithIframe = (src) => ({
    type: ActionTypes.POPUP_SHOW_IFRAME,
    src: src
})

export const showPopupOfferSharing = () => ({
    type: ActionTypes.POPUP_SHOW_OFFER_SHARING
})

export const closeAnyPopup = () => ({
    type: ActionTypes.POPUP_CLOSE_ANY
})



/** WEBPACK FOOTER **
 ** ./src/actions/Popup.js
 **/